<app-print-invoice-modal [email]='this.customerEmail' [selectedInvoices]='this.selectedInvoices'></app-print-invoice-modal>
<app-email-invoice-modal [email]='this.customerEmail' [selectedInvoices]='this.selectedInvoices'></app-email-invoice-modal>
<app-add-credit-note-invoice [email]='this.customerEmail'></app-add-credit-note-invoice>
<app-change-customer-modal [selectedInvoices]='this.selectedInvoices'></app-change-customer-modal>

<div class="fullcontainer" >
  <br />
  <br />


  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>All Invoices</h2>
    <div>
      <!-- <button class='btn btn-secondary'><i class="fas fa-paper-plane"></i> Post Invoices</button>&nbsp; -->
      <button class='btn btn-secondary' (click)='email()'><i class="fas fa-envelope"></i> Email Invoices</button>&nbsp;
      <button class='btn btn-secondary' (click)='print()'><i class="fas fa-print"></i> Print Invoices</button>&nbsp;
      <!-- Was "Financial Export", which built a Sage file from the ticked rows and recorded nothing.
           The new export is date-driven and records an attempt per document, so this navigates
           rather than acting on the selection - see the note the build screen shows on arrival. -->
      <button class='btn btn-secondary' [routerLink]='"/invoices/sage-export"'><i class="fas fa-file-invoice-dollar"></i> Sage Export</button>&nbsp;
      <button class='btn btn-secondary' [routerLink]='"/invoices/email-history"'><i class="fas fa-history"></i> Email History</button>&nbsp;
      <button class='btn btn-secondary' (click)="changeCustomer()"><i class="fas fa-user"></i> Change Customer</button>&nbsp;

    </div>
  </div>
  <br />
  <br />

  <div>
    <button class='btn greenHover' (click)='this.setInvoiceStatus("Open")'  [class.btn-success]='this.currentInvoiceStatus === "Open"' [class.btn-secondary]='this.currentInvoiceStatus !== "Accepted"'><i class="fas fa-check-circle"></i> Open Invoices</button>&nbsp;
    <button class='btn redHover' (click)='this.setInvoiceStatus("Close")'  [class.btn-danger]='this.currentInvoiceStatus === "Close"' [class.btn-secondary]='this.currentInvoiceStatus !== "Declined"'><i class="fas fa-times-circle"></i> Closed Invoices</button>&nbsp;
    <button class='btn blueHover' (click)='this.setInvoiceStatus("")' [class.btn-primary]='this.currentInvoiceStatus === ""' [class.btn-secondary]='this.currentInvoiceStatus !== ""'><i class="fas fa-money-check"></i> All Invoices</button>&nbsp;
  </div>
  <br />
  <br />

  <app-grid
entity='invoice'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
[checkboxSelector]='true'
(checkboxSelected)='this.onCheckedSelected($event)'
></app-grid>
